import barba from '@barba/core';
import { gsap } from "gsap";
import { run } from './app';
import { once } from './once';


export const barbaInit = () => {

// UPDATE HEAD TAGS
	barba.hooks.afterLeave((data) => {
		
		var headTags = [
	        "meta[name='keywords']",
	        "meta[name='description']",
	        "meta[property^='og']",
	        "meta[name^='twitter']",
	        "meta[itemprop]",
	        "link[itemprop]",
	        "link[rel='prev']",
	        "link[rel='next']",
	        "link[rel='canonical']",
	        "link[rel='alternate']"
	    ].join( ',' );

		var nextHtml = data.next.html;
		var newPage = document.createElement('div');
		newPage.innerHTML = nextHtml.trim();
		var newHeadTags = Array.prototype.slice.call(newPage.querySelectorAll(headTags));
		
		var pageHead = document.getElementsByTagName('head').item(0);
		var oldHeadTags = Array.prototype.slice.call(pageHead.querySelectorAll(headTags));

		oldHeadTags.forEach(function(el){
			pageHead.removeChild(el);
		});

		newHeadTags.forEach(function(el){
			pageHead.append(el);
		});

	});

	// UPDATE BODY CLASSES
	barba.hooks.afterLeave((data) => {

	  // Set <body> classes for "next" page
	  	var nextHtml = data.next.html;
	  	var body = document.querySelector('body');
	  	var responseRawHTML = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
	  	var responseRawEl = document.createElement('div');
	  	responseRawEl.innerHTML = responseRawHTML.trim();

	  	var responseEl = responseRawEl.getElementsByTagName('notbody');
	  	var bodyClasses = responseEl.item(0).classList;
	 	// var bodyClasses = div.getElementsByTagName('notbody').attr('class');

		body.classList = bodyClasses;
	});


	// Scroll top before enter
	barba.hooks.beforeEnter((data) => {

	  window.scrollTo(0, 0);

	});


	// RELOAD JS
	barba.hooks.enter((data) => {
		var nextHtmlEnter = data.next.container;
		run();
		// masonry(nextHtmlEnter);
	});

	barba.hooks.afterOnce((data) => {
	});

	// FORCE PAGE RELOAD ON POPSTATE
	window.onpopstate = function(event) {
		
		var popEventUrl = window.location.href;
		var popEventUrlString = String(popEventUrl)
	  	barba.force(popEventUrlString);

	};

	// LANG SWITCH ANIMATION TRIGGER
	barba.hooks.beforeLeave((data) => {

		var nextLang = data.trigger.lang;
		var backButton = document.querySelector('.menu__item__page__list-item-back');
		var langList = document.querySelector('.menu__item__lang__list');
		var pageList = document.querySelector('.menu__item__page__list');
		var nextPageURL = data.trigger.attributes.href.baseURI.split('/');
		var nextPageTarget = nextPageURL.pop() || nextPageURL.pop();
		var pathArray = window.location.href.split( '/' );
		var homeUrl = pathArray[2];

		if(nextLang == "fr-BE"){

			langList.classList.remove("menu__item__lang__list-en");
			langList.classList.add("menu__item__lang__list-fr");

		} else if (nextLang == "en-US"){
			langList.classList.remove("menu__item__lang__list-fr");
			langList.classList.add("menu__item__lang__list-en");

		} else if (nextPageTarget == "a-propos" || nextPageTarget == "about"){
			pageList.classList.remove("menu__item__page__list-work");
			pageList.classList.remove("menu__item__page__list-single");
			pageList.classList.add("menu__item__page__list-about");

		} else if (nextPageTarget == "accueil" || nextPageTarget == homeUrl){
			pageList.classList.remove("menu__item__page__list-about");
			pageList.classList.remove("menu__item__page__list-single");
			pageList.classList.add("menu__item__page__list-work");

		} else {
			pageList.classList.remove("menu__item__page__list-work");
			pageList.classList.remove("menu__item__page__list-about");
			pageList.classList.add("menu__item__page__list-single");

		}

	})

	const animationEnter = (container) => {
		var transiCont = document.querySelectorAll(container);
		return gsap.from(container, { 
			autoAlpha: 0,
			delay: .3,
			duration: 1,
			clearProps: 'all',
			ease: 'none',
			onComplete: () => 
				transiCont.forEach(async (cont) => {
			  		cont.style.visibility = "visible";
				})
		});
	}

	const animationLeave = (container, done) => {
		return gsap.to(container, { autoAlpha: 0, duration: 2, clearProps: 'all' , ease: 'none' });
	}

	barba.init({
		sync: true,
		debug: false,
		prefetchIgnore: false,
		preventRunning: false,
		transitions: [
			{
			    once(next) {
			    	animationEnter(".transiFade, .header");
			    },

			    leave(data) {
			    	var tl = gsap.timeline();
			      	tl.to(".transiFade", {
			        	duration: .45,
			        	autoAlpha: 0,
	        			display: 'none',
			      	})
			      	.to(".header", {
			        	duration: 0,
	        			display: 'none',
			      	});
			      	return tl;
			    },

			    enter(data) {
			    	var tl = gsap.timeline();
			      	tl.from(".transiFade", {
			        	duration: .45,
			        	autoAlpha: 0
			      	})
			      	.from(".header", {
			        	duration: 0,
			        	autoAlpha: 0
			      	});
			      	return tl;
			    },
		}]
	});
}